import React, {createContext} from 'react';

type Type = {
  getUseMessages: () => boolean;
  setMessages: (status: boolean) => void;
  confirm: (
    title?: string,
    message?: string | React.ReactNode,
    onlyConfirm?: boolean,
    primaryButtonText?: string,
  ) => Promise<boolean>;
};

export const ConfirmContext = createContext<Type>({
  getUseMessages: () => {
    return false;
  },
  setMessages: () => {},
  confirm: () => new Promise((_, reject) => reject()),
});
